/* eslint no-console:0 */

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { createApp } from '@vue/compat';
import Subscriptions from '../components/subscriptions.vue';
import { globalMixin, globalFilters } from '../mixins/global.js';
import { setupVueApp } from '../mixins/vue-setup.js';

document.addEventListener('turbolinks:load', () => {
  let element = document.getElementById('subscriptions');
  if (element != null) {
    const app = createApp({
      components: { Subscriptions },
      mixins: [globalMixin],
    });
    setupVueApp(app);
    app.mount(element);
  }
});

document.addEventListener('turbolinks:before-visit', () => {
  let element = document.getElementById('subscriptions');
  if (element != null && element.__vue_app__) {
    element.__vue_app__.unmount();
  }
});
